import React from 'react'

// components/Home.jsx
import { Heading } from '@aws-amplify/ui-react';
import { Row, Col } from 'react-bootstrap';

export function Home() {
  return (
    <>
      <Row className="justify-content-center">
        <Col lg={8} md={10}>
          <div className="moon-section">
            <strong>Moon Phase Today</strong>
            <div id="ex1" />
            {load_moon_phases(configMoon, moonToday)}
          </div>
        </Col>
      </Row>

      <Row className="justify-content-center mt-4">
        <Col lg={8} md={10}>
        <div className="welcome-section">
          <Heading level={3}>
            Welcome
          </Heading>

          <p>
            Welcome to <strong>Biophirom</strong>.
          </p>

          <p>
            Biophirom is a web platform that helps doctors keep track of the biorhythm of patients.
          </p>

          <h4>What is a Biorhythm?</h4>

          <p>
            A biorhythm is a theory suggesting that our physical energy, emotions, and intellectual ability follow natural repeating cycles.
          </p>

          <p>
            According to this theory, these cycles can influence how easy or difficult certain tasks may feel on specific days.
          </p>

          <h4>A Bit of History</h4>

          <p>
            The idea of biorhythms was first developed between 1897 and 1902, and it became widely known during the 1970s.
          </p>

          <h4>Additional Information</h4>

          <p>
            The moon phase of today is shown above as a helpful natural reference point.
          </p>
        </div>
        </Col>
      </Row>
    </>
  );
}

function load_moon_phases(obj, callback) {
  var gets = []
  for (var i in obj) {
    gets.push(i + "=" + encodeURIComponent(obj[i]))
  }
  gets.push("LDZ=" + new Date(obj.year, obj.month - 1, 1) / 1000)
  var xmlhttp = new XMLHttpRequest()
  var url = "https://www.icalendar37.net/lunar/api/?" + gets.join("&")
  xmlhttp.onreadystatechange = function () {
    if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
      callback(JSON.parse(xmlhttp.responseText))
    }
  }
  xmlhttp.open("GET", url, true)
  xmlhttp.send()
}

function moonToday(moon) {
  var day = new Date().getDate()
  var dayWeek = moon.phase[day].dayWeek
  var html = "<div>" +
    "<b>" + moon.nameDay[dayWeek] + "</b>" +
    "<div>" + day + " <b>" + moon.monthName + "</b> " +
    moon.year + "</div>" +
    "<div shadow>" + moon.phase[day].svg + "</div>" +
    "<div>" + moon.phase[day].phaseName + " " +
    "" + ((moon.phase[day].isPhaseLimit) ? "" : Math.round(moon.phase[day].lighting) + "%") +
    "</div>" +
    "</div>"
  document.getElementById("ex1").innerHTML = html
}

var configMoon = {
  lang: 'en',
  month: new Date().getMonth() + 1,
  year: new Date().getFullYear(),
  size: 150,
  lightColor: "rgb(255,255,210)",
  shadeColor: "black",
  texturize: false,
}